import Vue from "vue";
import Vuex from "vuex";
import VueResource from "vue-resource";
import { i18n } from "./i18n/i18n";
import { items } from "./items/items";
import { brand } from "./brand/brand";
import { shade } from "./shades/shade";
import { catalog } from "./catalog/catalog";
import { displays } from "./items/display";
import { plano } from "./plano/plano";
import { planos } from "./planos/planos";
import { user } from "./user/user";
import { roles } from "./user/roles";
import { functionality } from "./user/functionality";
import { versioning } from "./versioning/versioning";
import { categories } from "./categories/CategoriesStore";
import { ordersStore } from "./orders/OrdersStore";
import { orderWindowList } from "./orders/OrderWindowList";
import { order } from "./orders/order";
import { planonext } from "./planonext/planonext";
import { countdown } from "./countdown/CountDownStore";
import { comment } from "./comment/comment";
import { events } from "./events/events";
import { cguStore } from "./cguStore/cguStore";
import { basket } from "./basket/basket";
import { gui } from "./gui/gui";
import { shades } from "./shades/shades";
import { component } from "./search/component";
import { currentUser } from "./currrentUser/currentUser";
import { campaign } from "./campaign/campaign";
import { module } from "./module/module";
import { planoStats } from "@/store/planoStats";
import { currency } from "@/store/currency";
import { shippingMethod } from "@/store/shippingMethod";
import { forecast } from "@/store/forecast/forecast";

Vue.use(Vuex);
Vue.use(VueResource);

export const store = new Vuex.Store({
    modules: {
        user,
        roles,
        functionality,
        items,
        i18n,
        brand,
        shade,
        catalog,
        displays,
        plano,
        planos,
        versioning,
        categories,
        ordersStore,
        planonext,
        countdown,
        comment,
        events,
        cguStore,
        gui,
        basket,
        order,
        shades,
        component,
        orderWindowList,
        currentUser,
        campaign,
        module,
        planoStats,
        currency,
        shippingMethod,
        forecast
    }
});



// WEBPACK FOOTER //
// ./src/store/store.js